export default __webpack_public_path__ + "static/ACCESS4Me-Logo-a554f9e687bb375203760703f99e5f43.png";